module.exports = __webpack_public_path__ + "b.no2.d0813470.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/b.no2.jpg
// module id = oLvR
// module chunks = 0